import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PaymentPage = () => {
  const { invoiceId } = useParams();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState('');
  const [invoice, setInvoice] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  useEffect(() => {
    fetchInvoice();
    checkPaymentStatus();
  }, [invoiceId]);

  const checkPaymentStatus = async () => {
    const sessionId = searchParams.get('session_id');
    const paymentStatus = searchParams.get('payment');
    
    if (sessionId && paymentStatus === 'success') {
      setPaymentSuccess(true);
    } else if (paymentStatus === 'cancelled') {
      setError('Betaling geannuleerd. Probeer het opnieuw.');
    }
  };

  const fetchInvoice = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/invoices/${invoiceId}`);
      setInvoice(response.data);
      if (response.data.status === 'paid') {
        setPaymentSuccess(true);
      }
    } catch (err) {
      setError('Factuur niet gevonden.');
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = async () => {
    setProcessing(true);
    setError('');
    try {
      const response = await axios.post(`${API_URL}/api/payments/invoice/${invoiceId}/checkout`);
      if (response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (err) {
      setError('Kon betaling niet starten.');
      setProcessing(false);
    }
  };

  if (loading) {
    return (
      <div style={{minHeight: '100vh', background: '#1e3a5f', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <p style={{color: 'white', fontSize: '18px'}}>Laden...</p>
      </div>
    );
  }

  if (paymentSuccess) {
    return (
      <div style={{minHeight: '100vh', background: '#1e3a5f', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'}}>
        <div style={{background: 'white', borderRadius: '12px', padding: '40px', maxWidth: '500px', textAlign: 'center'}}>
          <div style={{width: '80px', height: '80px', background: '#d1fae5', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px'}}>
            <span style={{fontSize: '40px'}}>✓</span>
          </div>
          <h2 style={{color: '#1e3a5f', marginBottom: '10px'}}>Betaling Gelukt!</h2>
          <p style={{color: '#666'}}>Bedankt voor uw betaling. U ontvangt een bevestiging per e-mail.</p>
        </div>
      </div>
    );
  }

  if (error && !invoice) {
    return (
      <div style={{minHeight: '100vh', background: '#1e3a5f', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'}}>
        <div style={{background: 'white', borderRadius: '12px', padding: '40px', maxWidth: '500px', textAlign: 'center'}}>
          <h2 style={{color: '#dc2626'}}>Fout</h2>
          <p style={{color: '#666'}}>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{minHeight: '100vh', background: '#1e3a5f', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'}}>
      <div style={{background: 'white', borderRadius: '12px', maxWidth: '500px', width: '100%', overflow: 'hidden'}}>
        <div style={{background: '#f8fafc', padding: '20px', borderBottom: '1px solid #e2e8f0'}}>
          <h1 style={{margin: 0, fontSize: '20px', color: '#1e3a5f'}}>Van Vessem Sound & Lights</h1>
          <p style={{margin: '5px 0 0', color: '#64748b', fontSize: '14px'}}>Factuur Betalen</p>
        </div>
        
        <div style={{padding: '30px'}}>
          {error && <p style={{color: '#dc2626', marginBottom: '20px'}}>{error}</p>}
          
          <div style={{marginBottom: '30px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', padding: '15px 0', borderBottom: '1px solid #e2e8f0'}}>
              <span style={{color: '#64748b'}}>Factuurnummer</span>
              <span style={{fontWeight: 'bold'}}>{invoice?.invoiceNumber}</span>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', padding: '15px 0', borderBottom: '1px solid #e2e8f0'}}>
              <span style={{color: '#64748b'}}>Project</span>
              <span>{invoice?.project || '-'}</span>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', padding: '20px 0', background: '#f8fafc', marginTop: '15px', borderRadius: '8px', paddingLeft: '15px', paddingRight: '15px'}}>
              <span style={{fontSize: '18px', color: '#374151'}}>Te betalen</span>
              <span style={{fontSize: '28px', fontWeight: 'bold', color: '#1e3a5f'}}>€{invoice?.total || invoice?.amountt?.toFixed(2)}</span>
            </div>
          </div>
          
          <button
            onClick={handlePayment}
            disabled={processing}
            style={{
              width: '100%',
              padding: '18px',
              fontSize: '18px',
              fontWeight: 'bold',
              color: 'white',
              background: processing ? '#9ca3af' : '#10b981',
              border: 'none',
              borderRadius: '8px',
              cursor: processing ? 'not-allowed' : 'pointer'
            }}
          >
            {processing ? 'Laden...' : 'Nu Betalen'}
          </button>
          
          <p style={{textAlign: 'center', marginTop: '15px', color: '#9ca3af', fontSize: '13px'}}>
            Veilig betalen met iDEAL, Creditcard of Bancontact
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
